<template>
    <div >

        <!-- 1) quest titles -->
        <div class="TQ_padding_16px" >
            <div class="TQ_maxWidth_250px TQ_inline TQ_width_100p TQ_margin_0_4px" v-for="langCode in p_questExplore_c.qex_langArr_ae" :key="langCode" >
                <div class="TQ_text_bold TQ_align_initial">
                    {{ass_strings.oneWord_title[langCode]}} ({{format_langCode_fs(langCode)}})
                </div>
                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center" type="text" v-model="p_questExplore_c.qex_name_byLangCode_s[langCode]"/>
            </div>
        </div>

        <!-- 2) duration  -->
        <div class="TQ_padding_16px">
            <div class="TQ_maxWidth_250px TQ_inline TQ_width_100p TQ_margin_0_4px">
                <div class="TQ_text_bold TQ_align_initial"> {{ ass_strings.twoWords_durationMinutes[p_store_systemLangCode_e] }}</div>

                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center" type="number" min="0" max="300"
                       v-model.number.lazy="p_questExplore_c.qex_durationInMinutes_n"/>
                <div class="TQ_align_end TQ_text_14px">
                    [0, {{ gv_numbers.maxDurationMinutes}}]
                </div>
            </div>
        </div>

        <!-- 3) min/max players num-->
        <div class="TQ_padding_16px ">
            <div class="TQ_maxWidth_200px TQ_inline TQ_margin_0_4px">
                <div class="TQ_text_bold TQ_align_initial"> {{ ass_strings.twoWords_minPlayers[p_store_systemLangCode_e] }}</div>
                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center " type="number" min="0" v-model.number.lazy="p_questExplore_c.qex_minPlayersNum_n"/>
            </div>
            <div class="TQ_margin_4px TQ_inline"></div>
            <div class="TQ_maxWidth_200px TQ_inline">
                <div class="TQ_text_bold TQ_align_initial"> {{ ass_strings.twoWords_maxPlayers[p_store_systemLangCode_e] }}</div>
                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center" type="number" min="1" v-model.number.lazy="p_questExplore_c.qex_maxPlayersNum_n" />
            </div>
        </div>

        <!-- 4) langCodes-->
        <div class="TQ_padding_16px">

            <!-- supported languages  -->
            <div class="TQ_inline">

                <!-- label -->
                <div class="TQ_text_bold TQ_align_initial">
                    {{ ass_strings.oneWord_languages[p_store_systemLangCode_e] }}
                </div>

                <!-- languages  -->
                <div v-for="(langCode_e, index_n) in p_questExplore_c.qex_langArr_ae" class="TQ_inline TQ_width_125px TQ_verticalAlignTop TQ_margin_0_4px" :key="index_n">
                    <div class="TQ_verticalAlignMiddle TQ_padding_4px TQ_border TQ_borderRadius TQ_box_shadow TQ_borderBox">
                        <div class="TQ_grid_col_1frAuto TQ_direction_ltr">

                            <div class="TQ_grid_verticalCenter TQ_center">
                                {{format_langCode_fs(langCode_e)}}
                            </div>

                            <tq-dropdown :show-caret-down="false"  class="TQ_direction_rtl TQ_margin_bottom_-4px TQ_margin_-2px " :ps_only-mobile-mode_b="true">
                                <tq-image slot="select" :pb_src_r="ass_img_threeDots" class="TQ_width_24px TQ_margin_top_2px   TQ_clickable TQ_Animation_smallBigSmall_infinite_hover " />

                                <div slot="options" class="TQ_box_shadow2 TQ_clickable"  :style="{'direction' : helper_getDirectionByLangCode_fe(p_store_systemLangCode_e)}">
                                    <div class="TQ_border_bottom TQ_padding_8px TQ_bg_hover_purple"
                                         v-if="p_questExplore_c.qex_mainLang_e !== langCode_e"
                                         @click="m_deleteLangCode_f(langCode_e, index_n)">{{ ass_strings.oneWord_delete[p_store_systemLangCode_e] }}</div>

                                    <div slot="select" class="TQ_padding_8px TQ_bg_hover_purple" @click="m_popUp_show_changeLang_f(index_n)">{{ ass_strings.oneWord_change[p_store_systemLangCode_e] }}</div>

                                    <div v-if="p_questExplore_c.qex_mainLang_e !== langCode_e"
                                         @click="m_chooseDefaultLang(langCode_e)"
                                         class="TQ_padding_8px TQ_bg_hover_purple TQ_border_top">{{ass_strings.threeWords_defineAsDefault[p_store_systemLangCode_e]}}</div>
                                </div>

                            </tq-dropdown>

                        </div>
                    </div>

                    <div v-if="p_questExplore_c.qex_mainLang_e === langCode_e" class="TQ_align_initial TQ_text_12px TQ_text_bold TQ_text_capitalize">
                        {{ ass_strings.oneWord_default[p_store_systemLangCode_e]}}
                    </div>

                </div>

                <!-- add btn -->
                <div class="TQ_box_shadow TQ_inline TQ_border_green_2px TQ_borderRadius TQ_textColor_green TQ_text_bold TQ_border_g_2px TQ_padding_4px TQ_verticalAlignTop TQ_clickable TQ_margin_0_4px"                     
                    @click="m_popUp_show_addLang_f">

                    <svg_add class="TQ_verticalAlignMiddle TQ_width_20px TQ_height_20px TQ_svg_fill_g TQ_padding_1px TQ_Animation_smallBigSmall_infinite_hover"/>

                </div>


            </div>

        </div>

        <!-- 2) quest titles -->
        <div class="TQ_padding_16px TQ_border_bottom" >
            <div class="TQ_maxWidth_250px TQ_inline TQ_margin_4px" v-for="langCode in p_questExplore_c.qex_langArr_ae" >
                <div class="TQ_text_bold TQ_align_initial">
                    {{ass_strings.oneWord_title[langCode]}} {{format_langCode_fs(langCode)}}
                </div>
                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center" type="text" v-model="p_questExplore_c.qex_name_byLangCode_s[langCode]"/>
            </div>
        </div>

        <!-- 3) duration  -->
        <div class="TQ_padding_16px TQ_border_bottom">
            <div class="TQ_width_200px TQ_center">
                <div class="TQ_text_bold TQ_align_initial"> {{ ass_strings.twoWords_durationMinutes[p_store_systemLangCode_e] }}</div>

                <input class="TQ_text_20px TQ_padding_4px TQ_width_100p TQ_borderBox TQ_center " type="number" min="0" max="300"
                       v-model.number.lazy="p_questExplore_c.qex_durationInMinutes_n"/>
                <div class="TQ_align_end TQ_text_14px">
                    [0, {{ gv_numbers.maxDurationMinutes}}]
                </div>
            </div>
        </div>

        <!-- 4) min/max players num-->
        <div class="TQ_padding_16px TQ_border_bottom">
            <div class="TQ_maxWidth_200px TQ_inline">
                <div class="TQ_text_bold TQ_align_initial"> {{ ass_strings.twoWords_minPlayers[p_store_systemLangCode_e] }}</div>
                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center " type="number" min="0" v-model.number.lazy="p_questExplore_c.qex_minPlayersNum_n"/>
            </div>
            <div class="TQ_margin_4px TQ_inline"></div>
            <div class="TQ_maxWidth_200px TQ_inline">
                <div class="TQ_text_bold TQ_align_initial"> {{ ass_strings.twoWords_maxPlayers[p_store_systemLangCode_e] }}</div>
                <input class="TQ_padding_4px TQ_text_20px TQ_width_100p TQ_borderBox TQ_center" type="number" min="1" v-model.number.lazy="p_questExplore_c.qex_maxPlayersNum_n" />
            </div>
        </div>

        <!-- 5) boolean settings -->
        <div class="TQ_padding_16px ">

            <!-- 5.1) with guide / solo -->
            <div class="TQ_inline">
                <div class="TQ_inline TQ_padding_8px TQ_borderRadius TQ_center TQ_clickable TQ_box_shadow2 TQ_width_125px"
                     @click="p_questExplore_c.qex_metadata_c.qexm_guide_b = true"
                     :class="p_questExplore_c.qex_metadata_c.qexm_guide_b && 'TQ_bg_gold'">
                    <tq-image :pb_src_r="ass_svg_guide_b" class="TQ_width_40px TQ_margin_bottom_4px"/>
                    <div class="TQ_text_bold TQ_text_capitalize">
                        {{ ass_strings.twoWords_withAGuide[p_store_systemLangCode_e] }}
                    </div>
                </div>
                <div class="TQ_padding_4px TQ_inline"></div>
                <div class="TQ_inline TQ_padding_8px TQ_borderRadius TQ_center TQ_clickable TQ_box_shadow2 TQ_width_125px"
                     @click="p_questExplore_c.qex_metadata_c.qexm_guide_b = false"
                     :class="!p_questExplore_c.qex_metadata_c.qexm_guide_b && 'TQ_bg_gold'">
                    <tq-image :pb_src_r="ass_svg_noGuide_b" class="TQ_width_40px TQ_margin_bottom_4px"/>
                    <div class="TQ_text_bold TQ_text_capitalize">
                        {{ ass_strings.twoWords_whitoutGuide[p_store_systemLangCode_e] }}
                    </div>
                </div>
            </div>

            <!-- space -->
            <div class="TQ_padding_16px TQ_inline"></div>

            <!-- 5.2) virtual/outside -->
            <div class="TQ_inline">
                <div class="TQ_inline TQ_padding_8px TQ_borderRadius TQ_center TQ_clickable TQ_box_shadow2 TQ_width_125px"
                     @click="p_questExplore_c.qex_metadata_c.qexm_questLocationType_e = enum_questLocations_s.virtual"
                     :class="p_questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocations_s.virtual && 'TQ_bg_gold'">
                    <tq-image :pb_src_r="ass_img_online_b" class="TQ_width_40px TQ_margin_bottom_4px"/>
                    <div class="TQ_text_bold">
                        {{ ass_strings.oneWord_virtual[p_store_systemLangCode_e] }}
                    </div>
                </div>

                <div class="TQ_inline TQ_padding_4px"></div>

                <div class="TQ_inline TQ_padding_8px TQ_borderRadius TQ_center TQ_clickable TQ_box_shadow2 TQ_width_125px"
                     @click="p_questExplore_c.qex_metadata_c.qexm_questLocationType_e = enum_questLocations_s.outside"
                     :class="p_questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocations_s.outside && 'TQ_bg_gold'">
                    <tq-image :pb_src_r="ass_img_outdoor_b" class="TQ_width_40px TQ_margin_bottom_4px"/>
                    <div class="TQ_text_bold">
                        {{ ass_strings.oneWord_outdoor[p_store_systemLangCode_e] }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 6) starting location-->
        <div class="TQ_padding_16px" v-if="p_questExplore_c.qex_metadata_c.qexm_questLocationType_e !== enum_questLocations_s.virtual">

            <div class="TQ_text_bold">
                {{ ass_strings.twoWords_startingLocation[p_store_systemLangCode_e] }}
            </div>

            <!-- qex_startingLocation_s -->
            <input v-model="p_questExplore_c.qex_startingLocation_s"
                   @change="m_getStartingLocation"
                   :placeholder="ass_strings.twoWords_startingLocation[p_store_systemLangCode_e]"
                   type="search"
                   class="TQ_padding_4px TQ_text_20px TQ_center ">

            <!-- location -->
            <tq-leaflet-display-simple
                :key="server_qex_startingLocation_osms_c.osms_displayName_s"
                v-if="server_qex_startingLocation_osms_c"
                class="TQ_height_300px TQ_margin_bottom_8px TQ_maxWidth_500px TQ_center"
                :pb_center-map_c="server_qex_startingLocation_osms_c.osms_location_c"
                :p_display_lang-code_e="p_store_systemLangCode_e"
                :pb_zoom_n="15"
                :p_markers_ac="co_startingLocation_markers_ac"/>
            {{server_qex_startingLocation_osms_c && server_qex_startingLocation_osms_c.osms_displayName_s}}
        </div>

        <!-- popup add lang code-->
        <tq-popup :show="showPopup_availableLng_vb" max-width="200px" padding="0px">

            <div v-for="(langCode_e,index_n) in co_availableLanguages_ae"
                 class="TQ_padding_8px TQ_bg_hover_purple TQ_clickable" :class="index_n !== 0 && 'TQ_border_top'"
                 @click="m_popup_chooseLang_f(langCode_e)">
                {{format_langCode_fs(langCode_e)}}
            </div>

        </tq-popup>

    </div>
</template>

<script>
import {FB_QuestBody, FB_QuestExplore, FB_UserData} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import Popup from "../../../../components/basic/TqPopup";
    import Card from "../../../../components/basic/TqCard";
    import TqDropdown from "../../../../components/basic/TqDropdown";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
import {
    helper_forEachBlcFieldDo_f,
    helper_getDirectionByLangCode_fe,
    helper_getFbClassSize_s
} from "@/scripts/S_Helper";
import {
    ass_img_add_w,
    ass_img_garbage_w,
    ass_img_indoor_b,
    ass_img_language_w,
    ass_img_myLocation_gray,
    ass_img_online_b,
    ass_img_outdoor_b, ass_img_threeDots,
    ass_svg_guide_b,
    ass_svg_guide_c, ass_svg_noGuide_b,
    ass_svg_noGuide_c,
    ass_img_image,
} from "@/assets/scripts/Ass_Files";
    import TqImage from "@/components/basic/TqImage";
import {
    enum_moreInfo_featuresIds_s,
    enum_langCodes, enum_questLocationsTypes_s, enum_featuresMinPoints,
} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqPopup from "@/components/basic/TqPopup";
    import TqLeafletDisplay from "@/components/maps/TqLeafletDisplay";
    import TqLeafletDisplaySimple from "@/components/maps/TqLeafletDisplaySimple";
    import {Tq_Laeflet_Marker} from "@/classes/TqClasses";
    import {map_getLocation_f} from "@/scripts/API/S_Map";
    import Svg_add from "@/assets/svg/svg_add";
import {
    help_maxDurationTime_f,
} from "../../../../../functions/src/shareCode/Share_S_Helper";
import {gv_numbers} from "../../../../../functions/src/shareCode/Share_Ass_GlobalVariable";

    export default {

        name: "c_Creator_EditQuests_Item_ExploreBasic",
        components:{
            Svg_add,
            TqLeafletDisplaySimple,
            TqLeafletDisplay,
            TqPopup,
            TqImage,
            TqDropdown,
            Card,
            Popup,
        },
        props:{
            p_questExplore_c: {
                type :FB_QuestExplore,
                require: true,
            },
            p_questBody_c: {
                type :FB_QuestBody,
                require: true,
            },
            p_store_systemLangCode_e:{
                type :String,
                require: true,
            },
            p_creatorData_c:{
                type: FB_UserData,
                require: true
            }
        },
        data(){
            return{
                selectLangCode: null,
                showPopup_availableLng_vb: {val : false},
                swapLangIndex_n: null,

                // imports
                ass_svg_guide_c : ass_svg_guide_c,
                ass_svg_guide_b : ass_svg_guide_b,
                ass_svg_noGuide_c : ass_svg_noGuide_c,
                ass_svg_noGuide_b : ass_svg_noGuide_b,
                ass_img_add_w : ass_img_add_w,
                ass_img_garbage_w : ass_img_garbage_w,
                ass_img_threeDots : ass_img_threeDots,
                ass_img_myLocation_gray : ass_img_myLocation_gray,
                ass_img_language_w : ass_img_language_w,
                ass_img_outdoor_b : ass_img_outdoor_b,
                ass_img_indoor_b : ass_img_indoor_b,
                ass_img_online_b : ass_img_online_b,
                ass_img_image : ass_img_image,

                ass_strings : ass_strings,

                server_qex_startingLocation_osms_c : undefined,

                enum_questLocations_s   : enum_questLocationsTypes_s,
                enum_featuresIds_s      : enum_moreInfo_featuresIds_s,
                gv_numbers              : gv_numbers,
                enum_langCodes          : enum_langCodes,
                helper_getFbClassSize_s : helper_getFbClassSize_s,
                format_langCode_fs: format_langCode_fs,
                help_maxDurationTime_f : help_maxDurationTime_f,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,

            }
        },
        computed:{
            co_availableLanguages_ae(){
                let ans_ae = Object.values(enum_langCodes)

                return ans_ae.filter(langCode_e => !this.p_questExplore_c.qex_langArr_ae.includes(langCode_e))
            },
            co_startingLocation_markers_ac(){
                if(this.server_qex_startingLocation_osms_c == null){
                    return []
                }

                return [new Tq_Laeflet_Marker({
                    ltm_text_s      : this.server_qex_startingLocation_osms_c.osms_displayName_s,
                    ltm_location_c  :   this.server_qex_startingLocation_osms_c.osms_location_c
                })]
            },

        },
        methods:{

            // popup lngs
            m_popUp_show_changeLang_f(index_n){
                this.swapLangIndex_n = index_n
                this.showPopup_availableLng_vb.val = true
            },
            m_popUp_show_addLang_f(){
                this.swapLangIndex_n = null
                this.showPopup_availableLng_vb.val = true
            },
            m_popup_chooseLang_f(langCode_e){
                this.showPopup_availableLng_vb.val = false

                if(this.swapLangIndex_n == null){
                    this.p_questExplore_c.qex_langArr_ae.push(langCode_e)
                    this.m_updateQuestBodyLanguages_f()
                    this.m_addLangCode_f(langCode_e)
                }else{
                    if(this.p_questExplore_c.qex_langArr_ae[this.swapLangIndex_n] === this.p_questExplore_c.qex_mainLang_e){
                        this.p_questExplore_c.qex_mainLang_e = langCode_e
                    }

                    this.$set(this.p_questExplore_c.qex_langArr_ae, this.swapLangIndex_n, langCode_e)
                    this.m_updateQuestBodyLanguages_f()
                }
            },

            // lngs
            m_addLangCode_f(langCode_e) {

                let qex_mainLang_e = this.p_questExplore_c.qex_mainLang_e
                helper_forEachBlcFieldDo_f(this.p_questExplore_c, (filed_o, key_s) => {
                    if(key_s !== 'qex_langArr_ae' && filed_o[langCode_e] == null){
                        filed_o[langCode_e] = filed_o[qex_mainLang_e]
                    }
                })

                helper_forEachBlcFieldDo_f(this.p_questBody_c, (filed_o, key_s) => {
                    if(key_s !== 'qb_langArr_ae' && filed_o[langCode_e] == null){
                        filed_o[langCode_e] = filed_o[qex_mainLang_e]
                    }
                })
            },
            m_deleteLangCode_f(langCode_e, index_n){
                this.p_questExplore_c.qex_langArr_ae.splice(index_n,1)
                this.m_updateQuestBodyLanguages_f()
            },
            m_chooseDefaultLang(langCode_e){
                this.p_questExplore_c.qex_mainLang_e = langCode_e
                this.m_updateQuestBodyLanguages_f()
            },
            m_updateQuestBodyLanguages_f(){
                this.p_questBody_c.qb_langArr_ae = this.p_questExplore_c.qex_langArr_ae
                this.p_questBody_c.qb_mainLang_e = this.p_questExplore_c.qex_mainLang_e
            },

            m_getStartingLocation(){
                if(this.p_questExplore_c.qex_startingLocation_s){
                    map_getLocation_f(this.p_questExplore_c.qex_startingLocation_s, (osm_search_c) => {
                        this.server_qex_startingLocation_osms_c = osm_search_c

                        this.p_questExplore_c.qex_startingLocationPoint_c = osm_search_c.osms_location_c
                    })
                }
            },

        },
        mounted() {
            this.m_getStartingLocation()
        }

    }
</script>

<style scoped lang="scss">

    table {
        border-collapse: collapse;

        td, th, td {
            border: 1px solid black;
            padding: 4px;
            vertical-align: top;
        }
    }






</style>
